import * as yup from "yup";

export const schema = yup.object().shape({
  id: yup.number().notRequired(),
  name: yup.string().required().min(3).max(100),
  description: yup.string().required().min(3),
});